import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getStats } from '../../store/actions/stats';
import RetailerStats from '../../components/blocks/RetailerStats';
import Toolbar from '../../components/common/Toolbar';
import Wall from '../../components/common/Wall';
import Spinner from '../../components/common/Spinner';
import DateRange from '../../components/common/DateRange/DateRange';
import { endOfDay, startOfDay } from 'date-fns';

function RetailerStatsContainer(props) {
  const { getStats, id } = props;

  useEffect(() => {
    const startDate = localStorage.getItem('startDate')
      ? new Date(localStorage.getItem('startDate'))
      : startOfDay(new Date());
    const endDate = localStorage.getItem('endDate') ? new Date(localStorage.getItem('endDate')) : endOfDay(new Date());
    getStats(startDate, endDate, id);
  }, [getStats, id]);

  const handleChangeRange = (startDate, endDate) => {
    getStats(startDate, endDate, id);
  };

  if (props.isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <Toolbar name="Stats" grow>
        <Wall />
        <DateRange onChange={handleChangeRange} />
      </Toolbar>
      <RetailerStats {...props} />
    </>
  );
}

const mapStateToProps = (state) => {
  const { brands, replenish, totalIncome, totalItems, totalOrders, isLoading, filterRange } = state.stats;

  return {
    brands,
    replenish,
    totalIncome,
    totalItems,
    totalOrders,
    isLoading,
    filterRange,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getStats: (startDate, endDate, retailerId) => dispatch(getStats(startDate, endDate, retailerId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RetailerStatsContainer);

RetailerStatsContainer.defaultProps = {
  id: undefined,
};

RetailerStatsContainer.propTypes = {
  getStats: PropTypes.func.isRequired,
  id: PropTypes.number,
  isLoading: PropTypes.bool.isRequired,
};
